<template>
    <div class="label-wrapper" :class="{ 'label-content-left': labelPosition == 'left', 'label-content-inline': inline }">
        <div :style="labelStyle" v-show="label" :class="{ 'label-text': true, 'label-text-required': required }">{{ label }}</div>
        <div class="label-content">
            <slot />
        </div>
        <div class="label-error-msg" :style="messageStyle" v-if="errorMessage">{{ errorMessage }}</div>
    </div>
</template>

<script>
export default {
    name: "LabelWrapper",
    props: ["label", "labelWidth", "labelPosition", "required", "verifyInfo", "inline"],
    computed: {
        labelStyle() {
            return {
                width: `${this.labelWidth}px`
            };
        },
        messageStyle() {
            return {
                left: this.label ? `${parseInt(this.labelWidth, 10) + 10}px` : 0,
                bottom: this.label ? "1px" : 0
            };
        },
        errorMessage() {
            return this.verifyInfo && this.verifyInfo.message;
        }
    }
};
</script>

<style scoped lang="less">
.label-wrapper {
    position: relative;
    min-height: 32px;
    padding-bottom: 20px;
}
.label-content-left {
    display: flex;
    .label-text {
        padding: 7px 8px 3px 4px;
        text-align: left;
    }
    .label-content {
        flex: 1;
    }
}
.label-content-inline {
    display: inline-block;
    padding-bottom: 0;
    margin-right: 8px;
}
.label-text-required {
    &:before {
        content: "*";
        color: #f56c6c;
        margin-right: 4px;
        margin-left: -11px;
    }
}
.label-error-msg {
    position: absolute;
    bottom: 0;
    color: #f33535;
}
</style>
